const onBarcode = callback => {
  let chars     = []
  let isPressed = false
  const handler = (e) => {
    if ( e.which >= 48 && e.which <= 57 ) {
      chars.push( String.fromCharCode( e.which ) )
    }
    if ( isPressed === false ) {
      setTimeout( () => {
        if ( chars.length >= 7 ) {
          let barcode = chars.join( "" )
          // console.log( "Barcode Scanned: " + barcode )
          if ( callback && typeof callback === "function" ) callback( barcode )
        }
        chars     = []
        isPressed = false
      }, 500 )
    }
    isPressed = true
  }
  window.addEventListener( "keydown", handler )
  return () => window.removeEventListener("keydown", handler)
}

//var removeBarcodeListener = onBarcode( (barcode) => { console.info(`Barcode: ${barcode}`) })
// removeBarcodeListener() // clean up

export default onBarcode



// WEBPACK FOOTER //
// ./src/sdk/onBarcode.js